import script from "./ModalHorario.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalHorario.vue?vue&type=script&setup=true&lang=js"

import "./ModalHorario.vue?vue&type=style&index=0&id=4984b0e4&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4984b0e4"]])

export default __exports__